























































import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { IncidentReportType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import CTimePicker from '../inputs/CTimePicker.vue'
import MainMixin from '../../mixins/MainMixin'

@Component({
  components: {
    CDatePicker,
    CTimePicker,
  },
})
export default class IncidentReport extends Mixins(MainMixin) {
  @Prop() title!:string

  @Prop() shifts!:any

  @Prop() users!:any

  selectedDate = ''

  selectedTime = ''

  get date() {
    const date = dayjs(this.selectedDate).hour(Number(this.selectedTime.split(':')[0])).minute(Number(this.selectedTime.split(':')[1]))
    return date
  }

  types = [
    'Food Quality',
    'Food Timing',
    'Service Quality',
    'Service Timing',
    'Equipment Issue',
    'Stock Issue',
    'Other',
  ]

  priorities = [
    { text: 'Urgent', value: 5 },
    { text: 'High Priority', value: 4 },
    { text: 'Medium Priority', value: 3 },
    { text: 'Low Priority', value: 2 },
    { text: 'No Longer Applicable', value: 1 },
  ]

  data:IncidentReportType = {
    user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
    employee: '',
    datetime: new Date(),
    type: '',
    priority: '',
    description: '',
    resolution: '',
  }

  presubmit() {

  }

  clearForm() {
    this.data = {
      user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
      employee: '',
      datetime: new Date(),
      type: '',
      priority: '',
      description: '',
      resolution: '',
    }
    this.selectedTime = ''
    const observer:any = this.$refs.obs
    const datePicker:any = this.$refs.datepicker
    const timePicker:any = this.$refs.timepicker;
    ([datePicker, timePicker, observer]).forEach(x => x.reset())
  }

  numberComps = 0

  numberVoids = 0

  @Watch('datetime')
  dateChange(newDate:Date) {
    this.data.datetime = newDate
  }

  created() {
    if (!this.$store.getters.multiUser) {
      this.data.user = this.$store.getters.uid
    }
  }
}

